import { uid } from '../../../../lib/uid';

/**
 * A sample rung, so the create form fills in one click.
 *
 * **The rank is the awkward half and it is handled, not skipped.** A rank is unique among
 * active rungs and it is REQUIRED, so a generator leaving it at zero would fill every box and
 * leave Submit disabled — the one failure mode Autogenerate exists to prevent. The caller hands
 * in the ranks already taken and this returns the first free one from the bottom, which is
 * where a new rung almost always belongs: a ladder grows a weaker rung far more often than it
 * grows a stronger one.
 *
 * The name is suffixed because it is unique too, and Autogenerate is most useful clicked
 * repeatedly.
 */
export function sampleAccessLevel(takenRanks: readonly number[]): {
  name: string;
  rank: number;
  description: string;
} {
  const tag = uid().slice(0, 4).toUpperCase();

  let rank = 1;
  while (takenRanks.includes(rank)) rank += 1;

  return {
    name: `Level ${rank} ${tag}`,
    rank,
    description: `Sample rung ${tag}. Delete it once the real ladder is in.`,
  };
}
